// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3Zs9S","info":"UpdateTermsInfo_info__1BjOW"};